var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer-multioption multiple"},[_c('ol',{staticClass:"answer-list multi-list",class:_vm.question.question.class},_vm._l((_vm.option),function(q,idx){return _c('li',{key:("opt" + idx),class:{
        'answer-correct':
          _vm.sent && _vm.answerIndex.indexOf(_vm.optionOrder[idx]) !== -1,
        'res-answer-correct':
          _vm.sent &&
          _vm.selected.indexOf(idx) !== -1 &&
          _vm.answerIndex.indexOf(_vm.optionOrder[idx]) !== -1,
        'answer-incorrect':
          _vm.sent &&
          _vm.selected.indexOf(idx) === -1 &&
          _vm.answerIndex.indexOf(_vm.optionOrder[idx]) !== -1,
        'res-answer-incorrect':
          _vm.sent &&
          _vm.selected.indexOf(idx) !== -1 &&
          _vm.answerIndex.indexOf(_vm.optionOrder[idx]) === -1,
      },on:{"click":function () {
          if (!_vm.sent) {
            if (_vm.selected.indexOf(idx) === -1) {
              _vm.selected.push(idx);
            } else {
              _vm.selected.splice(_vm.selected.indexOf(idx), 1);
            }
          }
        }}},[_c('div',{staticClass:"boxes"},[(_vm.selected.indexOf(idx) !== -1)?_c('span',{staticClass:"num-box"},[_vm._v("✔")]):_c('span',{staticClass:"num-box"},[_vm._v("-")])]),(q)?_c('div',{staticClass:"options"},[_vm._v(_vm._s(q))]):_c('div',{staticClass:"options"},[_vm._v(_vm._s(_vm.circleNum[idx]))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }